import awaitToJs from 'await-to-js'
import {
  SET_NETWORKS_LIST,
  MESSAGE_ERROR,
  ALERT_COLORS,
  ALERT_DELAY,
} from '@App/constantes'
import { MANAGEMENT_API } from '@App/configs/rest'
import Fetch from '@App/helpers/fetch'
import { setAlertBox } from './snackbar'

const fetchGetNetwoksList = new Fetch()

export const setNetworksList = (data: any) => {
  return {
    type: SET_NETWORKS_LIST,
    payload: data,
  }
}

export const getNetworksList = () => {
  return async (dispatch: any, getState: any) => {
    const [err, data] = await awaitToJs(
      fetchGetNetwoksList.get({
        url: `${MANAGEMENT_API}/networks`,
        headers: {
          'X-Organization-ID': getState().user.user.organizationId,
        },
        params: {
          'per-page': 100,
          page: 1,
        },
      }),
    )

    if (!err && data) {
      dispatch(setNetworksList(data))

      return data
    }

    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }
  }
}
